<div class="wrap">
  <div class="header">
      <div class="title">
          <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active" appChangeColorTheme attribute="color"></fa-icon>
          <h2>Liste des utilisateurs</h2>
      </div>

      <div class="add_search_user">
          <div class="add_user" (click)="addUser()" appChangeColorTheme [isHover]="true">
              <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
              <span>Ajouter un utilisateur</span>
          </div>
          <div class="search_bar">
            <form [formGroup]="searchForm">
                <input type="text" placeholder="Chercher un utilisateur ..." (input)="applyFilter($event.target.value)" formControlName="keyword">
            </form>
            <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes" *ngIf="valueInput" ></fa-icon>
            <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput" ></fa-icon>
          </div>
      </div>
  </div>

  <div class="content" [hidden]="isLoading">
    <div class="list-users mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="userName" class="cell_club">Identifiant</th>
          <td mat-cell *matCellDef="let element" class="cell_club"> {{element.userName}} </td>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName" class="cell_club">Nom</th>
          <td mat-cell *matCellDef="let element" class="cell_club"> {{element.lastName}} </td>
        </ng-container>

        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName" class="cell_club">Prénom</th>
          <td mat-cell *matCellDef="let element" class="cell_club"> {{element.firstName}} </td>
        </ng-container>

        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="role" class="cell_club">Rôle</th>
          <td mat-cell *matCellDef="let element" class="cell_club"> {{element.role}} </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="email" class="cell_club">Email</th>
          <td mat-cell *matCellDef="let element" class="cell_club"> {{element.email}} </td>
        </ng-container>

        <ng-container matColumnDef="actorCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="actorCode" class="cell_club">Code acteur</th>
          <td mat-cell *matCellDef="let element" class="cell_club"> {{element.actorCode}} </td>
        </ng-container>

        <ng-container matColumnDef="details">
          <th mat-header-cell *matHeaderCellDef class="cell_action"></th>
          <td mat-cell *matCellDef="let element" class="cell_action">
              <div class="actions">
                <ng-container *ngIf="element.isInitialized">
                  <fa-icon [icon]="getFaIcon('faLock')" (click)="resetPassword(element)" matTooltip="Réinitialiser le mot de passe" matTooltipPosition="above" appChangeColorTheme attribute="color" ></fa-icon>
                </ng-container>
                <ng-container *ngIf="!element.isInitialized">
                  <fa-icon [icon]="getFaIcon('faEnvelope')" (click)="resentInvit(element)" matTooltip="Renvoyer une invitation" matTooltipPosition="above" appChangeColorTheme attribute="color" ></fa-icon>
                </ng-container>
                <ng-container *ngIf="role === 'admin' || role === 'AdminSITE'">
                  <fa-icon [icon]="getFaIcon('faPen')" (click)="editUser(element)" matTooltip="Éditer" matTooltipPosition="above" appChangeColorTheme attribute="color" ></fa-icon>
                  <fa-icon [icon]="getFaIcon('faTrash')" (click)="deleteUser(element)" matTooltip="Supprimer" matTooltipPosition="above" appChangeColorTheme attribute="color" ></fa-icon>
                </ng-container>
              </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
      <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          (page)="pageEvent = $event" [color]="color">
      </mat-paginator>
  </div>
</div>
